import React from 'react';
import { Layers } from '../../stores/layers';

export function TextSearch({ layers, config }) {
  const openSearchLayer = layers.openLayer.bind(null, Layers.search);
  return config.features.search ? (
    <div className="bg-white w-12 h-12 cursor-pointer relative flex items-center justify-center text-neutral-500 text-xl rounded-full shadow-md transition-all" onClick={openSearchLayer}>
      <span className="icon icon-search text-2xl text-neutral-800" />
    </div>
  ) : null;
}
